// React
import React from 'react';
// Material-UI
import { Paper } from '@material-ui/core';
// Otras libs

// Componentes

// Vistas

// Servicios

// Funciones

// Hooks


/**
 * 
 * @typedef {Object} Props
 * @property {bool} usaFondo Si muestra fondo blanco
 */

/**
 * Sección destinada a contenido del contenedor
 * @param {Props} props
 * @param {ChildrenFn} props.children
 * @returns 
 */
export const ContenidoContenedor = ({ 
    usaFondo = true,
    children,
}) => {
    // Idioma
    
    // Token
    
    // Estados

    // Listas
    
    // Funciones

    // Vista
    return (usaFondo
        ? (
            <Paper elevation={0} style={{ paddingTop: '30px', paddingBottom: '30px', paddingLeft: '10px', paddingRight: '10px', boxShadow: "rgb(209 209 209 / 25%) 0px 1px 4px, rgb(209 209 209 / 35%) 0px 3px 12px 2px" }}>
                {children}
            </Paper>
        )
        : (
            <div style={{ paddingTop: '10px', paddingBottom: '30px', paddingLeft: '10px', paddingRight: '10px' }}>
                {children}
            </div>
        )
    );
};
